// Properly cached navigate instance
import { useRef } from 'react';
import { useNavigate as useNavigateFromReactRouter } from 'react-router-dom';

const useNavigate = () => {
  const navigate = useNavigateFromReactRouter();
  const navigateRef = useRef(navigate);

  return navigateRef.current;
};

export default useNavigate;
